// extracted by mini-css-extract-plugin
export default {"message":"src-app-components-ErrorDisplay-style__w8iNM__message","buttons":"src-app-components-ErrorDisplay-style__t9EeP__buttons"};